// MentionText.jsx
// Renders text with @username mentions as colored, clickable links.
// Clicking a mention opens the user's profile on moondala.one in a new tab.
import React from "react";

const USER_APP_BASE =
  process.env.REACT_APP_USER_APP_URL ||
  (typeof window !== "undefined" && ["localhost", "127.0.0.1"].includes(window.location.hostname)
    ? "http://localhost:5173"
    : "https://moondala.one");

/**
 * @param {string} text  – raw comment/reply text
 * @param {string} [className] – optional extra className on the wrapper <span>
 */
export default function MentionText({ text, className }) {
  if (!text) return null;

  // Split on @word boundaries (letters, digits, underscores, dots)
  const parts = text.split(/(@[\w.]+)/g);

  return (
    <span className={className}>
      {parts.map((part, i) => {
        if (/^@[\w.]+$/.test(part)) {
          const username = part.slice(1); // strip leading @
          return (
            <a
              key={i}
              href={`${USER_APP_BASE}/profile/${username}`}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
              style={{
                color: "#a78bfa",
                fontWeight: 600,
                textDecoration: "none",
                cursor: "pointer",
              }}
              title={`View ${part}'s profile`}
            >
              {part}
            </a>
          );
        }
        return <React.Fragment key={i}>{part}</React.Fragment>;
      })}
    </span>
  );
}
